import { render, staticRenderFns } from "./NotificationSettingsAlertsTable.vue?vue&type=template&id=2ec0cbf8"
import script from "./NotificationSettingsAlertsTable.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsAlertsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports